import React, { createContext, useMemo } from 'react';
import { App } from '@roku-web-core/app';

interface ConfigContext {
  baseUrl: string;
  endpoints: Record<string, string>;
  mobileDeeplink: string;
  csrfToken: string;
}

export const ConfigContext = createContext<ConfigContext>({
  baseUrl: '',
  endpoints: {},
  mobileDeeplink: '',
  csrfToken: '',
});

interface ConfigProviderProps {
  children: React.ReactNode;
}

export const ConfigProvider = ({ children }: ConfigProviderProps) => {
  const { pageviewPrereqData } = App.getPageConfig();
  const { microsite: baseUrl, endpoints, csrf: csrfToken } = App.getResource();

  const mobileDeeplink = pageviewPrereqData?.mobileDeeplink || 'https://smarthome.roku.com';

  const contextValue = useMemo(
    () => ({ baseUrl, endpoints, mobileDeeplink, csrfToken }),
    [baseUrl, endpoints, mobileDeeplink, csrfToken],
  );

  return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
};
